'use client';

import { Flexbox, Tooltip } from '@doc/ui-components';
import { AbbEnvelope } from '@doc/ui-components/icons';
import { usePathname, useTranslations } from '@power-core/toolkit';
import { useTheme } from 'next-themes';
import { useModal } from '@/shared/modal/hooks/use-modal.hook';
import type { HeaderProps } from '../types/header.type';
import { HeaderLogo } from './header-logo.ui';
import { HeaderProjectName } from './header-project-name.ui';
import { LanguageMenu } from './language-menu.ui';
import { ThemeToggle } from './theme-toggle.ui';
import { UserMenu } from './user-menu.ui';
import { useFilters } from '@/shared/filters/hooks/use-filters.hook';
import { STUDY_TITLES } from './header.const';

export const Header = ({ locales, supportedLocales, title, subtitle }: HeaderProps) => {
	const t = useTranslations();
	const { resolvedTheme } = useTheme();
	const { openModal } = useModal();
	const { filters } = useFilters();
	const pathname = usePathname();
	const subtitleTest =
		pathname.includes('selectivity') || pathname.includes('backup') ? t(STUDY_TITLES[filters.type as keyof typeof STUDY_TITLES]) : subtitle;

	return (
		<Flexbox
			direction='row'
			justify='between'
			alignContent='center'
			items='center'
			className='w-full py-4 px-6 relative shadow-none border-none dark:bg-bg_dark shrink-0'
		>
			<HeaderLogo title={title} subtitle={subtitleTest} />
			<HeaderProjectName />
			<Flexbox items='center' justify='center' className='gap-6'>
				<ThemeToggle />
				<Tooltip content={t('T_SUPPORT')}>
					<AbbEnvelope
						size={24}
						fill={resolvedTheme === 'dark' ? '#f1f1f1' : '#1f1f1f'}
						className='cursor-pointer'
						onClick={() => openModal('SUPPORT', undefined)}
					/>
				</Tooltip>
				<LanguageMenu supportedLocales={supportedLocales} locales={locales} />
				<UserMenu />
			</Flexbox>
		</Flexbox>
	);
};
